import React from 'react';
/* eslint-disable */
export function InApp(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10 18C11.0938 18 12 17.125 12 16H8C8 17.125 8.875 18 10 18ZM16.7188 13.3438C16.125 12.6875 14.9688 11.7188 14.9688 8.5C14.9688 6.09375 13.2812 4.15625 11 3.65625V3C11 2.46875 10.5312 2 10 2C9.4375 2 9 2.46875 9 3V3.65625C6.6875 4.15625 5 6.09375 5 8.5C5 11.7188 3.84375 12.6875 3.25 13.3438C3.0625 13.5312 3 13.7812 3 14C3 14.5312 3.40625 15 4 15H15.9688C16.5938 15 16.9688 14.5312 17 14C17 13.7812 16.9062 13.5312 16.7188 13.3438Z"
        fill="currentColor"
      />
    </svg>
  );
}
